import styled from '@emotion/styled';
import { useEffect } from 'react';
import ZaloLogo from 'assets/zalo-logo.svg';

interface ZaloShareButtonProps {
  url: string;
  zaloOAId: string;
  size?: string;
}

export const ZaloShareButton: React.FC<ZaloShareButtonProps> = ({
  url,
  size = '26',
  zaloOAId,
}) => {
  useEffect(() => {
    // Gọi reload để init lại widget nếu cần
    if (typeof window !== 'undefined' && window.ZaloSocialSDK) {
      window.ZaloSocialSDK.reload();
    }
  }, [url]);

  return (
    <StyledZaloIcon
      className="zalo-share-button"
      data-href={url}
      data-oaid={zaloOAId}
      data-customize={true}
      size={size}
    />
  );
};

const StyledZaloIcon = styled.div<{
  size?: string;
}>`
  width: ${(prop) => prop.size}px;
  height: ${(prop) => prop.size}px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${ZaloLogo});
  cursor: pointer;
`;
